import React from 'react';
import { Typography } from '@material-ui/core';
import styles from '../InstructionsStyles';

const Instr17 = () => {
  return (
    <div style={styles.container}>
      <Typography variant="subtitle1" style={styles.madeBy}>
        Утвърдил: Габриела Илиева
      </Typography>

      <Typography variant="subtitle1" style={styles.madeBy}>
        Старши експерт &quot;Здравословна работна среда&quot;
      </Typography>

      <Typography variant="subtitle1" style={styles.title}>
        За безопасна работа с оптични кабели
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>1. До работа с оптични кабели </b>се допускат само лица, които са преминали съответното
        обучение и инструктаж и притежават не по-ниска от трета квалификационна група по безопасност
        на труда, съгласно изискванията на Правилника по безопасността на труда при работа по
        въздушни и кабелни съобщителни линии и мрежи Д-0б-001/1997г.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          2. <span style={styles.warning}>Забранено е </span>
        </b>
        присъствието на лица, неучастващи в полагането, изтеглянето, монтажа и измерването на
        оптични кабели, около отворени кабелни шахти, тунели, колектори, както и в близост до изкопа
        и до машините за полагане и изтегляне на кабел.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>3. При работа задължително </b>да се използват одобрените и предоставени съобразно
        степента на риска лични предпазни средства, за вида, употребата и начина на съхранение на
        които работещите са инструктирани (и обучени за използването на тези ЛПС, за които това е
        необходимо).
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          4. <span style={styles.warning}>Забранява се </span>
        </b>
        работа с неизправни лични предпазни средства и с такива с изтекъл срок на годност и на
        периодична проверка.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          5. <span style={styles.warning}>Забранява се </span>
        </b>
        извършването на работи по оптични кабели в шахти, тунели и колектори само от един човек.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          6. <span style={styles.warning}>Забранява се </span>
        </b>
        строителство, ремонт и поддържане на оптични линии и мрежи без предварително утвърден проект
        и/или писмено разрешение от организацията, която стопанисва или експлоатира тези оптичните
        съоръжения.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>7. При работа с оптични кабели на открито</b>, работното място да се обезопасява с
        предпазни ограждения, като при необходимост се поставят и предупредителни пътни знаци.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>8. За осветление </b>в шахти, тунели и колектори да се ползват преносими лампи със
        захранващо напрежение до 12 V.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>9. Допуска се</b> използване на защитно изолирани преносими лампи (от клас II) за
        номинално напрежение 220 V в среда с повишена и особена опасност, ако дължината на
        захранващия кабел не превишава 10 т.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>10. Използваните преносими трансформатори или акумулатори</b> да се полагат на
        повърхността на земята на разстояние не по-малко от 1 m от ръба на отвора на кабелната
        шахта, тунел или колектор.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>11. Товаренето и разтоварването на кабелни барабани </b>да се извършва с изправни
        повдигателни съоръжения, снабдени със задържащо устройство.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          12. <span style={styles.warning}>Забранено е </span>
        </b>
        разтоварването на кабелни барабани от превозното средство чрез блъскане и събаряне.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>13. При изтегляне на кабел </b>в подземна телефонна тръбна мрежа кабелният барабан да се
        поставя на хоризонтален участък така, че да не пречи на движението на пешеходци и пътни
        превозни средства.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>14. Приспособленията за изтегляне </b>на оптичен кабел (ролки, дъги, устия и др.) да се
        спускат и изваждат от кабелните шахти, тунели и колектори с помощта на въже. Забранява се на
        работещите да стоят под тях.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          15. <span style={styles.warning}>Забранява се </span>
        </b>
        използването на рейка, изработена от стъкловлакна без защитни или с нарушено полимерно
        покритие.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>16. При инсталиране </b>на изтеглящо въже или оптичен кабел по пневматичен начин,
        отговорният изпълнител задължително да проверява правилността и надеждността на монтажа на
        компонентите от системата за подаване на въздух под налягане.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          17. <span style={styles.warning}>Забранено е :</span>
        </b>
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - стоенето пред отвора на тръбата, от който се очаква да излезе буталото; отворът
          задължително се обезопасява с предпазна преграда.
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - стоенето на лица в кабелната шахта, в която се очаква да излезе буталото.
        </Typography>
      </div>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>18. При механизирано изтегляне </b>и полагане на оптичен кабел задължително да се
        осигурява сигнализация между лицата, контролиращи лебедката и кабелния барабан и лицата по
        участъците от кабелното трасе.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          19. <span style={styles.warning}>Забранено е </span>
        </b>
        при механизирано изтегляне на оптичен кабел в подземна телефонна тръбна мрежа:
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - използването на машини, които не са специално предназначени за тази цел;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - ръчното направляване на кабела или теглещото въже;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - отстраняването в движение на преплитания на теглещото въже.
        </Typography>
      </div>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>20. При изтегляне на оптичен кабел</b> по метода на изстрелване работната група
        задължително включва: правоспособен компресорист; обучен специалист, работещ с апарата за
        изстрелване; обучен специалист, работещ с кабелното ремарке.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>21. Преди започване на работа </b>да се проверяват изправността на спирачката на кабелния
        барабан и всички връзки на въздухопровода между компресорната уредба и апарата за
        изстрелване.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>22. При изстрелване на оптичен кабел </b>налагането от компресора да се подава
        постепенно.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          23. <span style={styles.warning}>Забранява се </span>
        </b>
        захващането на оптичния кабел с ръце на разстояние по-малко от 5 m преди апарата за
        изстрелване.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>24. Действащите оптични кабели</b> да се срязват само след писмено разрешение от
        организацията-собственик, след тяхното идентифицирани и след издаден наряд.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>25. Подготовката на оптичния кабел </b>и оптичните влакна да се извършва само при
        изключена измервателна апаратура и изключено крайно линийно оборудване.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          26. <span style={styles.warning}>Забранена е </span>
        </b>
        работа с оптични влакна без потвърждение за изключено крайно линийно оборудване.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>27. Преди започване на работа </b>металните елементи на обшивката, бронята и
        екранировката на оптичния кабел да се заземят със стационарен или преносим заземител.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>28. Корпусът на заваръчния апарат </b>да е защитен от индиректен допир.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>29. Забранено е да се докосват електродите на включен заваръчен апарат.</b>
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>30. При срязване на влакно</b>, остатъкът да се прибира в специална кутия с капак за
        остатъци от оптични влакна. При напълване на кутията тя се залива с адхезив до получаване на
        компактна маса и се изхвърля с отпадъци, неподлежащи на рециклиране.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          <span style={styles.warning}>31. Забранява се :</span>
        </b>
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - гледането в оптичния изход на източниците на оптичен сигнал; насочване на оптични влакна
          и оптични съединители към очите;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - насочване на тръбичката или отвора на бутилката със специален газ за почистване на
          оптичните съединители и адаптери към очите.
        </Typography>
      </div>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>32. В случаите, когато при измерване</b> параметрите на оптични влакна се работи в две
        точки от кабелното трасе, задължително да се осигурява служебна телефонна или радио връзка
        между двете групи.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          33. <span style={styles.warning}>Забранено е </span>
        </b>
        извършването на всякакви манипулации с оптичните влакна или оптичните съединители в далечния
        край на кабела, по който се извършват измерванията, преди получаване на съобщение от близкия
        край, че лазерният източник е изключен.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>34. При разединяване </b>на оптичния съединител от измервателния уред, предварително
        уредът да се изключва, а изходът на лазерния източник се затваря с предпазен елемент,
        непропускащ лазерно лъчение.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          35. <span style={styles.warning}>Забранено е </span>
        </b>
        извършването на измервания по оптичния кабел преди окончателното завършване на процеса на
        свързване на оптичното влакно в муфата.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>36. При работа с оптични кабели</b>
        <span style={styles.warning}> се забранява </span>
        хранене, пиене и пушене.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>37. След приключване на работа </b>работното облекло да се почиства чрез изтупване, а
        ръцете да се измиват и намазват с неутрален крем.
      </Typography>

      <Typography style={styles.date}>
        <b>7.10.2024г.</b>
      </Typography>
    </div>
  );
};
export default Instr17;
